var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full mb-1 text-sm font-semibold cursor-default"},[_vm._v(" Booking for ")])
}
var staticRenderFns = []

export { render, staticRenderFns }